import * as React from 'react';

import { FlagIcon } from '@icons';

import useIsInIframe from '@hooks/use-is-in-iframe';

import i18n, { languagesKeys } from '@/i18n';

import * as Styled from './lang-switcher.styled';

const LangSwitcher = () => {
	const isIframe = useIsInIframe();
	const savedLang = localStorage.getItem('appLanguage') || i18n.language;

	const [lang, setLang] = React.useState(savedLang);
	const [showLangSwitcher, setShowLangSwitcher] = React.useState(false);

	const handleLangSwitcher = () => {
		setShowLangSwitcher(!showLangSwitcher);
	};

	const handleLangChange = (newLang: string) => {
		if (lang !== newLang) {
			setLang(newLang);
			localStorage.setItem('appLanguage', newLang);
			setShowLangSwitcher(false);
			window.location.reload();
		}
	};

	if (isIframe) {
		return null;
	}

	return (
		<>
			{showLangSwitcher && <Styled.PageOverflow onClick={() => setShowLangSwitcher(false)} />}

			<Styled.Wrapper onClick={handleLangSwitcher}>
				<Styled.DesktopIcon>
					<FlagIcon lang={lang} />
					{lang}
				</Styled.DesktopIcon>
				{showLangSwitcher && (
					<Styled.Switcher>
						{languagesKeys.map((language: string) => (
							<Styled.Lang
								key={language}
								$isSelected={lang === language}
								onClick={() => handleLangChange(language)}
								$isFirst={language === languagesKeys[0]}
							>
								<Styled.LangLeft>
									<FlagIcon lang={language} />
									{language}
								</Styled.LangLeft>
								<Styled.LangCheckbox $selected={lang === language} />
							</Styled.Lang>
						))}
					</Styled.Switcher>
				)}
			</Styled.Wrapper>
		</>
	);
};

export default LangSwitcher;
